import { getDictationStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';

export default mutatorAction(
    'setDictationLanguagePickerDropdown',
    function setDictationLanguagePickerDropdown(dictationLanguageMenuItems: IContextualMenuItem[]) {
        getDictationStore().languagePickerDropDown = dictationLanguageMenuItems;
    }
);
